import script from "./AdminGeneral.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminGeneral.vue?vue&type=script&setup=true&lang=js"

import "./AdminGeneral.vue?vue&type=style&index=0&id=759a4441&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-759a4441"]])

export default __exports__